import {useAppContext} from "./useAppContext";
import {erpService} from "../api/erpService";
import {ApolloClients} from "../api/clients";
import {PromotionModel} from "../models/domain/promotionModel";
import {useSuspenseQuery} from "@apollo/client";
import {PromotionEnumType} from "../definitions/enums";

export const useCouponCodeQuery: () => { couponModel?: PromotionModel; error?: string } = () => {
    const {productId} = useAppContext();

    const {
        error,
        data
    } = useSuspenseQuery(erpService.product.promotion, {
        errorPolicy: 'all',
        context: {
            clientName: ApolloClients.ErpService
        },
        variables: {
            productId: productId
        }
    });

    // Logic
    // 1. If there is no promotion, return undefined
    // 2. If there is a single product promotion, return the promotion
    // 3. If there is an error, return the error
    return {
        couponModel: data?.promotion?.type === PromotionEnumType.SingleProduct ? new PromotionModel(data.promotion) : undefined,
        error: error?.message
    };
}